<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M7.44 15.19a1.5 1.5 0 012.12 0L24 29.628l14.44-14.44a1.5 1.5 0 012.12 2.122l-15.5 15.5a1.5 1.5 0 01-2.12 0l-15.5-15.5a1.5 1.5 0 010-2.122z"/></svg>